/**
 * Utility to unregister all existing service workers
 * This should be imported and run when the application starts
 */

export const unregisterServiceWorkers = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      
      if (registrations.length > 0) {
        console.log(`Unregistering ${registrations.length} service worker(s)...`);
        
        for (const registration of registrations) {
          await registration.unregister();
          console.log('Successfully unregistered service worker:', registration.scope);
        }
        
        console.log('All service workers have been unregistered');
      } else {
        console.log('No service workers to unregister');
      }
      
      return true;
    } catch (error) {
      console.error('Error unregistering service workers:', error);
      return false;
    }
  } else {
    console.log('Service workers not supported in this browser');
    return false;
  }
}; 